<template>
  <div>
    <div v-if="user === 'Staff'">
      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div
            :class="[
              'circle',
              cotejo.validaSolicitantes == 1 || cotejo.currentComponentValues.ValidaComparecientes ? 'completado' : '',
            ]"
          >
            <span class="number">
              <i
                v-if="cotejo.validaSolicitantes == 1 || cotejo.currentComponentValues.ValidaComparecientes"
                class="fa fa-check"
              ></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'ValidaComparecientes' ? 'active-menu' : 'text-menu'"
            @click="selected('ValidaComparecientes')"
          >
            Solicitante
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer" v-if="cotejo.envio_domicilio === 1">
        <div class="ml-3">
          <div :class="['circle', cotejo.validaDomicilio == 1 || cotejo.currentComponentValues.Domicilio ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.validaDomicilio == 1 || cotejo.currentComponentValues.Domicilio" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Domicilio' ? 'active-menu' : 'text-menu'" @click="selected('Domicilio')">
            Domicilio de entrega
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div
            :class="[
              'circle',
              cotejo.currentComponentValues.ValidaCotizacion || cotejo.currentComponentValues.ValidaCotizacion
                ? 'completado'
                : '',
            ]"
          >
            <span class="number">
              <i
                v-if="cotejo.currentComponentValues.ValidaCotizacion || cotejo.currentComponentValues.ValidaCotizacion"
                class="fa fa-check"
              ></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'ValidaCotizacion' ? 'active-menu' : 'text-menu'"
            @click="selected('ValidaCotizacion')"
          >
            Cotización y datos de pago
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div
            :class="[
              'circle',
              cotejo.validaDocumentos == 1 || cotejo.currentComponentValues.ValidaDocumentos ? 'completado' : '',
            ]"
          >
            <span class="number">
              <i v-if="cotejo.validaDocumentos == 1 || cotejo.currentComponentValues.ValidaDocumentos" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'ValidaDocumentos' ? 'active-menu' : 'text-menu'"
            @click="selected('ValidaDocumentos')"
          >
            Descripción documentos
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.corredurias_id || cotejo.currentComponentValues.Correduria ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.corredurias_id || cotejo.currentComponentValues.Correduria" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Correduria' ? 'active-menu' : 'text-menu'" @click="selected('Correduria')">
            Asignar correduría
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.EntregaDocumentosOriginales ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.EntregaDocumentosOriginales" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'EntregaDocumentosOriginales' ? 'active-menu' : 'text-menu'"
            @click="selected('EntregaDocumentosOriginales')"
          >
            Entrega de originales en correduría
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.RevisionDocumentosOriginales ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.RevisionDocumentosOriginales" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'RevisionDocumentosOriginales' ? 'active-menu' : 'text-menu'"
            @click="selected('RevisionDocumentosOriginales')"
          >
            Revisión de originales
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div
            :class="[
              'circle',
              [19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus) ||
              this.cotejo.cotizaciones_id_complementario ||
              cotejo.currentComponentValues.PagoComplementario
                ? 'completado'
                : '',
            ]"
          >
            <span class="number">
              <i
                v-if="
                  [19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus) ||
                  this.cotejo.cotizaciones_id_complementario ||
                  cotejo.currentComponentValues.PagoComplementario
                "
                class="fa fa-check"
              ></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a
            :class="selectedComponent === 'PagoComplementario' ? 'active-menu' : 'text-menu'"
            @click="selected('PagoComplementario')"
          >
            Pago complementario
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.CotejoListo ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.CotejoListo" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a :class="selectedComponent === 'CotejoListo' ? 'active-menu' : 'text-menu'" @click="selected('CotejoListo')">
            Cotejo listo
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', [20, 21].includes(this.cotejo.id_estatus) || cotejo.currentComponentValues.Actas ? 'completado' : '']">
            <span class="number">
              <i v-if="[20, 21].includes(this.cotejo.id_estatus) || cotejo.currentComponentValues.Actas" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a :class="selectedComponent === 'Actas' ? 'active-menu' : 'text-menu'" @click="selected('Actas')">
            Documentos digitales
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', [20, 21].includes(cotejo.id_estatus) || cotejo.currentComponentValues.Expediente ? 'completado' : '']">
            <span class="number">
              <i v-if="[20, 21].includes(cotejo.id_estatus) || cotejo.currentComponentValues.Expediente" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a :class="selectedComponent === 'Expediente' ? 'active-menu' : 'text-menu'" @click="selected('Expediente')">
            Expediente
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.id_estatus == 21 || cotejo.currentComponentValues.Terminado ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.id_estatus == 21 || cotejo.currentComponentValues.Terminado" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Terminado' ? 'active-menu' : 'text-menu'" @click="selected('Terminado')">Terminado</a>
        </div>
      </div>

      <!-- <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', [19, 20, 21, 75, 76].includes(this.cotejo.id_estatus) ? 'completado' : '']">
            <span class="number">
              <i v-if="[19, 20, 21, 75, 76].includes(this.cotejo.id_estatus)" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a :class="selectedComponent === 'FAD' ? 'active-menu' : 'text-menu'" @click="selected('FAD')">FAD</a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.validaDocumentos == 1 ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.validaDocumentos == 1" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>

        <div class="ml-3">
          <a
            :class="selectedComponent === 'EstatusDocumentos' ? 'active-menu' : 'text-menu'"
            @click="selected('EstatusDocumentos')"
          >
            Estatus Documentos
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.validaDocumentosComplementarios == 1 ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.validaDocumentosComplementarios == 1" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'DocumentosComplementarios' ? 'active-menu' : 'text-menu'"
            @click="selected('DocumentosComplementarios')"
          >
            Documentos Complementarios
          </a>
        </div>
      </div> -->
    </div>

    <div v-else-if="user === 'Client'">
      <div class="row">
        <div class="col-12 text-center mb-3">
          <label>Entrega de información base</label>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Solicitante</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Lugar de Entrega</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Documentos</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div class="circle completado">
            <span class="number">
              <i class="fa fa-check"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <span class="text-menu">Cotización</span>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.Pago ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.Pago" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Pago' ? 'active-menu' : 'text-menu'" @click="selected('Pago')">Pago</a>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center mb-3">
          <label>Complementa la información</label>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.Solicitantes == 1 ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.Solicitantes == 1" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Solicitantes' ? 'active-menu' : 'text-menu'" @click="selected('Solicitantes')">
            Solicitante
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer">
        <div class="ml-3">
          <div :class="['circle', cotejo.id_estatus >= 16 && cotejo.id_estatus !== 44 ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.id_estatus >= 16 && cotejo.id_estatus !== 44" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Documentos' ? 'active-menu' : 'text-menu'" @click="selected('Documentos')">
            Documentos
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer" v-if="cotejo.envio_domicilio === 1">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.Domicilio ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.Domicilio" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a :class="selectedComponent === 'Domicilio' ? 'active-menu' : 'text-menu'" @click="selected('Domicilio')">
            Domicilio de Entrega
          </a>
        </div>
      </div>

      <div class="row flex align-items-center p-2 pointer" v-if="cotejo.pago_complementario">
        <div class="ml-3">
          <div :class="['circle', cotejo.currentComponentValues.PagoComplementario ? 'completado' : '']">
            <span class="number">
              <i v-if="cotejo.currentComponentValues.PagoComplementario" class="fa fa-check"></i>
              <i v-else class="fa fa-minus"></i>
            </span>
          </div>
        </div>
        <div class="ml-3">
          <a
            :class="selectedComponent === 'PagoComplementario' ? 'active-menu' : 'text-menu'"
            @click="selected('PagoComplementario')"
          >
            Pago Complementario
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeCotejo",

  props: {
    cotejo: { type: Object },
    user: { type: String },
    selectedComponent: { type: String },
  },

  methods: {
    selected(node) {
      this.$emit("node", node);
    },
  },
};
</script>

<style scoped>
.completado {
  background-color: yellowgreen !important;
}

.number {
  font-size: 11px;
  color: white;
}
</style>
